<section class="policy-page">
  <div class="container policy-shell">
    <section class="policy-stage">
      <div class="policy-stage-backdrop"></div>
      <div class="policy-stage-overlay"></div>

      <div class="policy-stage-inner">
        <div class="policy-intro">
          <p class="eyebrow">Company Policy</p>
          <h1>Our Commitments To Integrity And Performance</h1>
          <p class="policy-lead">
            A tech-driven venture builder focused on strategic growth. We identify high-potential
            opportunities, establish robust foundations, and scale innovative businesses designed
            for long-term endurance.
          </p>
        </div>

        <div class="policy-body">
          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Ethics &amp; compliance</h2>
              <p>
                Tricore Holdings Pvt. Ltd. adheres to transparent governance, fair procurement
                practices, and anti-corruption standards across all partnerships.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Quality assurance</h2>
              <p>
                We apply rigorous QA checkpoints across design, procurement, and construction to
                safeguard safety and durability.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Sustainability</h2>
              <ul class="policy-points">
                <li>Energy-efficient building systems and renewable integrations.</li>
                <li>Waste reduction strategies during construction and operations.</li>
                <li>Community engagement and inclusive urban planning.</li>
              </ul>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Partner expectations</h2>
              <p>
                We collaborate with partners who share our commitment to performance, transparency,
                and sustainable growth.
              </p>
            </div>
          </article>
        </div>

        <p class="policy-meta">Updated: March 27, 2026</p>
      </div>
    </section>
  </div>
</section>
